import { useMutation, useQueryClient } from '@tanstack/react-query';
import { userApi } from '@entities/user';
import { useToast } from '@shared/ui';
import type { UUID } from '@shared/api';

export function useBlockUser(id: UUID) {
  const qc = useQueryClient();
  const toast = useToast();
  return useMutation({
    mutationFn: (reason: string) => userApi.block(id, reason),
    onSuccess: () => {
      toast.success('Пользователь заблокирован');
      void qc.invalidateQueries({ queryKey: ['user', id] });
      void qc.invalidateQueries({ queryKey: ['audit'] });
    },
    onError: (e: Error) => toast.error('Не удалось заблокировать', e.message),
  });
}

export function useUnblockUser(id: UUID) {
  const qc = useQueryClient();
  const toast = useToast();
  return useMutation({
    mutationFn: () => userApi.unblock(id),
    onSuccess: () => {
      toast.success('Пользователь разблокирован');
      void qc.invalidateQueries({ queryKey: ['user', id] });
      void qc.invalidateQueries({ queryKey: ['audit'] });
    },
    onError: (e: Error) => toast.error('Не удалось разблокировать', e.message),
  });
}
